import { formatDistanceToNow } from "date-fns"

export function formatTimestampUTC(timestamp: string | number | Date): string {
  const date = new Date(timestamp)
  const month = date.toLocaleString("en-US", {
    month: "long",
    timeZone: "UTC",
  })
  const day = date.getUTCDate()
  const year = date.getUTCFullYear()
  const hours = date.getUTCHours().toString().padStart(2, "0")
  const minutes = date.getUTCMinutes().toString().padStart(2, "0")
  return `${month} ${day}, ${year} ${hours}:${minutes} UTC`
}

export function formatTimestampUTCDate(
  timestamp: string | number | Date
): string {
  const date = new Date(timestamp)
  const month = date.toLocaleString("en-US", {
    month: "short",
    timeZone: "UTC",
  })
  const day = date.getUTCDate()
  const year = date.getUTCFullYear()
  return `${month} ${day}, ${year}`
}

export function formatTimestampToRelative(
  timestamp: string | number | Date
): string {
  const date = new Date(timestamp)

  // Get the timezone offset in milliseconds
  const timezoneOffset = date.getTimezoneOffset() * 60000
  // Create a new date object in UTC by subtracting the offset
  const utcDate = new Date(date.getTime() - timezoneOffset)
  const now = new Date()
  const utcNow = new Date(now.getTime() - now.getTimezoneOffset() * 60000)

  // We need to check if it was "yesterday" in UTC.
  // We can't use date-fns's isYesterday directly as it uses local time.
  const yesterdayUTC = new Date(utcNow.getTime())
  yesterdayUTC.setUTCDate(yesterdayUTC.getUTCDate() - 1)

  const isYesterdayInUTC =
    utcDate.getUTCFullYear() === yesterdayUTC.getUTCFullYear() &&
    utcDate.getUTCMonth() === yesterdayUTC.getUTCMonth() &&
    utcDate.getUTCDate() === yesterdayUTC.getUTCDate()

  if (isYesterdayInUTC) {
    return "yesterday"
  } else if (formatDistanceToNow(date) === "1 day") {
    return "yesterday"
  }
  return formatDistanceToNow(date, { addSuffix: true })
}

export function formatTimestampLocal(
  timestamp: string | number | Date
): string {
  const date = new Date(timestamp)
  return new Intl.DateTimeFormat(undefined, {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    timeZoneName: "short",
  }).format(date)
}
